import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';

const InfoCard = ({ startIcon, text1, text2, onArrowClick ,color="#444" }) => {
  return (
    <Box
      variant="outlined"
      className='grid-item'
    >
      <Box display="flex" alignItems="center">
        <Box mr={1}>{startIcon}</Box>
        <Box>
          <Typography style={{color,fontSize:"14px",fontWeight:"500"}}>{text1}</Typography>
          <Typography style={{color,fontSize:"12px",fontWeight:"bold"}}>{text2}</Typography>
        </Box>
      </Box>
      <IconButton onClick={onArrowClick}>
        <ArrowForwardIos fontSize="medium" />
      </IconButton>
    </Box>
  );
};

export default InfoCard;
